<template>
  <div class="map-box">
    <div
      id="container"
      class="map"
    />
  </div>
</template>

<script>
import iconMapStart from '@/assets/img/icon_map_start.png';
import iconPosition from '@/assets/img/mark_bs.png';
import iconMapEnd from '@/assets/img/icon_map_end.png';
import { mapState } from 'vuex';
export default {
  components: {
  },
  props: {
    taskDetail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      times: 0, // 计数器
      marker: '',
      map: '',
      baseLng: 116.397428,
      baseLat: 39.90923,
      detail: {},
      startIcon: iconMapStart, // 起点icon（师傅icon、救援icon、起点icon）
      currentIcon: iconPosition, // 当前icon（师傅icon、救援icon、起点icon）
      endIcon: iconMapEnd // 终点icon（终点icon、师傅icon）
    };
  },
  computed: {
    ...mapState('orderGeneral', {
      currentPosition: state => state.currentPosition
    })
  },
  created() {
  },
  mounted() {
  },
  watch: {
    taskDetail(val) {
      if (val) {
        this.detail = val;
        if (this.currentPosition) {
          this.getMap();
        }
      }
    },
    currentPosition() {
      console.log('currentPosition+++---:', this.currentPosition);
      // 每10s刷新一次地图
      this.times += 1;
      if (this.times % 2 === 0) {
        if (this.map && this.currentPosition) {
          this.getMap();
        }
      }
    }
  },
  methods: {
    getMap() {
      // 创建地图
      const _this = this;
      if (!this.map) {
        this.map = new AMap.Map('container');
      }
      this.map.clearMap();

      // 只有起点
      this.markers = [];
      if (!this.detail.destLongitude || !this.detail.destLatitude) {
        const marker = new AMap.Marker({
          position: [_this.detail.longitude, _this.detail.latitude],
          // 坐标偏移
          icon: _this.startIcon,
          draggable: true,
          map: _this.map
        });
        _this.markers.push(marker);
        _this.map.setFitView();
        return;
      }
      // 绘制轨迹路线;
      const driving = new AMap.Driving();
      // 根据起终点经纬度规划驾车导航路线
      driving.search(
        new AMap.LngLat(this.currentPosition.longitude || '', this.currentPosition.latitude || ''),
        new AMap.LngLat(this.detail.destLongitude || '', this.detail.destLatitude || ''),
        function(status, result) {
          if (status === 'complete') {
            if (result.routes && result.routes.length) {
              // 绘制第一条路线，也可以按需求绘制其它几条路线
              drawRoute(result.routes[0]);
            }
          } else {
            console.log('获取驾车数据失败：' + result);
          }
        }
      );

      function drawRoute(route) {
        console.log('route: ', route);
        const path = parseRouteToPath(route);
        const startMarker = new AMap.Marker({
          position: path[0],
          icon: _this.currentIcon,
          map: _this.map
        });
        startMarker.setIcon('//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png');
        const endMarker = new AMap.Marker({
          position: path[path.length - 1],
          icon: _this.endIcon,
          map: _this.map
        });
        const routeLine = new AMap.Polyline({
          path: path,
          isOutline: true,
          outlineColor: '#ffeeee',
          borderWeight: 2,
          strokeWeight: 5,
          strokeColor: '#0091ff',
          lineJoin: 'round'
        });
        routeLine.setMap(_this.map);

        // 调整视野达到最佳显示区域
        _this.map.setFitView([startMarker, endMarker, routeLine]);
      }
      function parseRouteToPath(route) {
        const path = [];
        for (let i = 0, l = route.steps.length; i < l; i++) {
          const step = route.steps[i];
          for (let j = 0, n = step.path.length; j < n; j++) {
            path.push(step.path[j]);
          }
        }
        return path;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.map{
  width: 100vw;
  height: 100vh;
}
</style>
